import {connect} from 'react-redux';
import Merch from './Merch';

const getActualState = (state) =>(
    {
        state
    }
)

const actions = (dispatch) =>(
    {
        eventsActions: (type,payload) => dispatch({type,...payload})
    }
)

export default connect(getActualState,actions)(Merch);